import { OFFERS } from '../../constants/offers';

const OffersHeader = ({ className = "" }) => {
  if (!OFFERS.active) return null;

  return (
    <div
      className={`w-full py-2 px-1 text-center text-sm md:text-base font-medium relative overflow-hidden ${className}`}
      style={{
        backgroundColor: OFFERS.backgroundColor,
        color: OFFERS.textColor
      }}
    >
      <div
        className="animate-marquee whitespace-nowrap"
        dangerouslySetInnerHTML={{ __html: OFFERS.text }}
      />
      {/* <style jsx>{`
        @keyframes marquee {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
        .animate-marquee {
          display: inline-block;
          animation: marquee 15s linear infinite;
        }
      `}</style> */}
    </div>
  );
};

export default OffersHeader;
